import { RequestStatus } from 'features/request/requestSlice';
import { Loader } from 'uikit';

interface ITableLoaderProps {
    requestStatus?: RequestStatus;
    textEmptyData?: string;
}

export const TableLoader = ({ requestStatus, textEmptyData = 'Нет данных' }: ITableLoaderProps) =>
    requestStatus === RequestStatus.FETCHING ? <Loader /> : <span>{textEmptyData}</span>;

TableLoader.displayName = 'TableLoader';
